// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"index-module--titleContainer--3KpNG","title":"index-module--title--1UngK","list":"index-module--list--3a44D"};